import Swiper, {Navigation} from 'swiper';

Swiper.use([Navigation]);

const sliderInit = () => {
	const articleSlider = document.querySelectorAll('.article__slider');

	articleSlider.forEach((slider) => {
		// eslint-disable-next-line no-new
		new Swiper(slider, {
			spaceBetween: 60,
			speed: 500,
			centeredSlides: true,
			navigation: {
				nextEl: '.article__arrow--next',
				prevEl: '.article__arrow--prev',
			},
			breakpoints: {
				1024: {
					spaceBetween: 22,
					slideToClickedSlide: true,
				},
			},
		});
	});
};

export {sliderInit};

